import { render, staticRenderFns } from "./financialStatements.vue?vue&type=template&id=1b848fd7&scoped=true"
import script from "./financialStatements.vue?vue&type=script&lang=js"
export * from "./financialStatements.vue?vue&type=script&lang=js"
import style0 from "./financialStatements.vue?vue&type=style&index=0&id=1b848fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b848fd7",
  null
  
)

export default component.exports